import React, { Component } from 'react';
import { VictoryPie, VictoryAnimation, VictoryLabel } from "victory";

class Rates extends Component {
	constructor(props) {
		super(props);
		this.state = {
		  	percent: 0, data: this.getData(0)
		};
		if(props!=null && props.target!=null && props.target != 0){
			this.animate();
		}
	}

	animate(){
		let target = this.props.target;
		let percent = 0;
		this.setStateInterval = window.setInterval(() => {
			percent += 1;
			if(percent >= target){
				this.setState({
					percent, data: this.getData(target)
				});
				window.clearInterval(this.setStateInterval);
			}
			this.setState({
				percent, data: this.getData(percent)
			});
		}, 1);
	}
	componentDidMount() {
		

	}
	componentWillUnmount() {
		window.clearInterval(this.setStateInterval);
	}
	
	getData(percent) {
		return [{ x: 1, y: percent }, { x: 2, y: 100 - percent }];
	}

	render() {
		return (
			<>
				<div
					id="rates"
					style={{
						visibility: 'hidden',
						position: 'fixed',
						backgroundColor: 'rgba(255, 255, 255, 0)',
						height: '64px',
						width: '64px'
					}}
				>
					<svg viewBox="0 0 400 400" width="100%" height="100%">
						<VictoryPie
							standalone={false}
							animate={{ duration: 1 }}
							width={400} height={400}
							data={this.state.data}
							innerRadius={120}
							cornerRadius={25}
							labels={() => null}
							style={{
							data: { fill: ({ datum }) => {
								const color = datum.y > 30 ? "green" : "red";
								return datum.x === 1 ? color : "transparent";
							}
							}
							}}
						/>
						<VictoryAnimation duration={500} data={this.state}>
							{(newProps) => {
							return (
								<VictoryLabel
								textAnchor="middle" verticalAnchor="middle"
								x={200} y={200}
								text={`${Math.round(newProps.percent)}%`}
								style={{ fontSize: 45 }}
								/>
							);
							}}
						</VictoryAnimation>
					</svg>
				</div>
			</>
		);
	}
}

export default Rates;
